import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formatDateTime } from "../../common-data/Converts";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { scheduler_types } from "../../common-data/DropdowData";

const BCASchedulerListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { bcaScheduler, bcaSchedulerLoading, bcaSchedulerError } = useSelector(
    (state) => state.blog
  );

  const initialDatas = {
    pagination: [],
    getResults: [],
  };
  const [getAPIData, setGetAPIData] = useState(initialDatas);

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: `/wati/schedule_broadcast`,
              queryParams: {
                uid: filter?.uid,
              },
            })
          ).unwrap();

          console.log("response=> ", response);

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !bcaSchedulerLoading &&
      !bcaSchedulerError &&
      bcaScheduler?.status &&
      bcaScheduler?.data?.length > 0
    ) {
      setGetAPIData((prevs) => ({
        ...prevs,
        allData: bcaScheduler.data,
        pagination:
          bcaScheduler?.pagination?.length > 0 ? bcaScheduler.pagination : [],
      }));
    } else {
      setGetAPIData(initialDatas);
    }
  }, [bcaScheduler, bcaSchedulerLoading, bcaSchedulerError]);

  const tbColumns = [
    {
      dataField: "condition_type",
      text: "schedule type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.condition_type
              ? scheduler_types.find(
                  (item) => item.value === row.condition_type
                )?.label
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "scheduler name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
    // {
    //   dataField: "whatsapp_account",
    //   text: "wati account",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">
    //         {row?.whatsapp_account?.replace(/_/g, " ") || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "channel",
      text: "whatsapp templates",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "wp_template",
                rowData: row,
              }))
            }>
            {row?.templates?.length || "View"} Templates
          </span>
        );
      },
    },
    {
      dataField: "condition",
      text: "condition",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.condition || "-"}</span>;
      },
    },
    {
      dataField: "before_day",
      text: "sent before (days)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.before_day || "-"}</span>;
      },
    },
    {
      dataField: "after_day",
      text: "sent after (days)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.after_day || "-"}</span>;
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "description",
                rowData: row,
              }));
            }}>
            view
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data minWidth150 ${
              !row?.status ? "" : "withPadding borderRdius27"
            }`}
            style={{
              background: !row?.status
                ? "transparent"
                : row?.status === "active"
                ? "#379C00"
                : row?.status === "pending"
                ? "#F97A00"
                : "#D90000",
              color: !row?.status ? "#000" : "#fff",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none">
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };

              handleDelete(filters);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none">
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {bcaSchedulerLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={getAPIData.allData}
            tableColumns={tbColumns}
            tablePagination={getAPIData.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default BCASchedulerListings;
